import { TaskTimeSetting } from '@/views/dashboard/_components/task-time/task-time.service'
import { SettingsResCommon } from '@/views/dashboard/policy/policy-common.service'

export interface StrategySettings {
  /** 总开关 */
  main_switch?: boolean
  frequency?: number
  regular_tasks?: TaskTimeSetting[]
}

export const DEFAULT_SETTING: StrategySettings = {
  main_switch: true,
  frequency: 1,
  regular_tasks: [{ target: 1, start_min: 0, end_min: 23 * 60 + 50 }]
}

export interface SettingsRes extends SettingsResCommon {
  /** 策略内容(json) ，特定的类型才返回，如软件禁用策略 */
  strategy: StrategySettings
}
